import type { ReactNode } from 'react';
import {
  CircularProgress,
  DialogTitle,
  DialogContent,
  Typography,
  styled,
  Dialog,
} from '@mui/material';

const PREFIX = 'ProgressDialog';

const classes = {
  progressDialogHeader: `${PREFIX}-progressDialogHeader`,
  progressDialogContent: `${PREFIX}-progressDialogContent`,
};

type ProgressDialogProps = {
  title: string;
  content: ReactNode;
  open: boolean;
  onClose?: () => void;
};

const StyledDialog = styled(Dialog)(({ theme }) => ({
  ['& .MuiPaper-root']: {
    width: '444px',
    padding: theme.spacing(4),
  },
  [`& .${classes.progressDialogHeader}`]: {
    textAlign: 'center',
    fontFamily: 'Bitter',
    fontSize: '30px',
    fontWeight: '700',
    lineHeight: '40px',
    letterSpacing: '0.25px',
    color: 'rgba(0, 0, 0, 0.87)',
    marginBottom: theme.spacing(7),
  },
  [`& .${classes.progressDialogContent}`]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(5),
    textAlign: 'center',
    fontFamily: 'Source Sans Pro',
    fontSize: '14px',
    fontWeight: '600',
    lineHeight: '21.98px',
    letterSpacing: '0.1px',
  },
}));

const ProgressDialog = ({
  title,
  content,
  open,
  onClose,
}: ProgressDialogProps) => {
  return (
    <StyledDialog open={open} onClose={onClose}>
      <DialogTitle className={classes.progressDialogHeader}>
        {title}
      </DialogTitle>
      <DialogContent className={classes.progressDialogContent}>
        <CircularProgress size={224} />
        <Typography>{content}</Typography>
      </DialogContent>
    </StyledDialog>
  );
};

export { ProgressDialog };
